import { actions } from './slice';

export * from './thunks';

export const { authRequest, authSuccess, authError, signupSuccess, authFailure } = actions;
